var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ribbon',{staticClass:"has-background-white has-border-top",attrs:{"padding":"none"}},[_c('div',{staticClass:"has-padding-left-100 has-padding-right-100"},[_c('horizontal-nav',{attrs:{"routes":_vm.routes,"is-borderless":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }